import PythonApi from "@/services/PythonApi";

export default {

  getGateways(){
    const url = "gateway/list";

    return PythonApi().get(url);
  },
  manageGateways(){
    const url = "gateway/manage-gateways";

    return PythonApi().post(url);
  },
  getCowsNotSeen(){
    const url = "cows/not-seen";

    return PythonApi().get(url)
  },
  getCowsWithHighPM(){
    const url = "cows/pending-messages";

    return PythonApi().get(url)
  }
};



// WEBPACK FOOTER //
// ./src/api/technical-statuses-api.js